import React, { Component } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import Header from './Header';
import 'react-toastify/dist/ReactToastify.css';

export default function (ComposedClass, reload, page = '') {
  class AuthenticationCheck extends Component {
    state = {
      loading: true,
      user: '',
    }

    componentWillMount() {
      axios.post('/api/auth',{}, { headers:{Authorization: localStorage.getItem('token') } })
        .then((response) => {
          this.setState({ loading: false, user: response.data });

          // console.log(response.data);
          if (!response.data.isAuth) {
            // if user is not logged in and reload page is true, redirect to login, if reload is true, you hae to be logged in
            if (reload) {
              this.props.history.push('/');
            }
          } else {
            // if the user is logged in and the reload is false go the the dashboard
            if (reload === false) {
              this.props.history.push('/dashboard');
            }
          }
        }).catch((err) => {
          console.error(err.response);
          this.setState({ loading: false });

          this.props.history.push('/');
        });
    }


    render() {
      if (this.state.loading) {
        return (
          <Container>
            {' '}
            <Row>
              <Col md={3} className="mx-auto my-3 text-center">
                <FontAwesome name="spinner" size="2x" style={{ color: '#c82590' }} spin />
              </Col>
            </Row>
          </Container>
        );
      }
      return (
        <div>
          {
            page === 'login' || page === 'register' ? null
              : <Header {...this.props} user={this.state.user} />
          }
          <ComposedClass {...this.props} user={this.state.user} />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      );
    }
  }


  return AuthenticationCheck;
}
